import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import TestimonialTabs from "./testimonialTabs";
import { getDetailTestimonial } from "../../store/actions";

const AdminTestimonialApproval = ({ match, getDetailTestimonial, initialValues, history }) => {
	const testimonialId = (match && match.params && match.params.id) || null;

	useEffect(() => {
		getDetailTestimonial(`${testimonialId}`);
	}, [getDetailTestimonial, testimonialId]);

	return (
		<section className="page page-admin-testimonial-approval">
			<div className="container">
				<h3 className="mb-3"> Testimonial </h3>
				<div className="card-wrap">
					<div className="card card-primary tab-primary w-100">
						{initialValues && initialValues.id && <TestimonialTabs match={match} history={history} />}
					</div>
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Testimonials } = state;
	return {
		initialValues: get(Testimonials, "testimonialDetail", {})
	};
};

const mapDispatchToProps = { getDetailTestimonial };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AdminTestimonialApproval);
